import { JsonObject, JsonProperty } from 'json2typescript';

import { FeeInterface, IdInterface } from '../../../core';
import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('Fee')
export class Fee implements FeeInterface {
    @JsonProperty('ModelPortfolioId', IdAdapter)
    private _modelId: Id = undefined;

    @JsonProperty('InitialInvestment', Number)
    private _investment: number = undefined;

    @JsonProperty('EvaluationType', StringAdapter, true)
    private _evaluationType: string = undefined;

    constructor(investment = 0, modelId?: IdInterface) {
        this._investment = investment;
        this._modelId = modelId as Id;
    }

    get modelId(): Id {
        return this._modelId;
    }

    set modelId(value: Id) {
        this._modelId = value;
    }

    get investment(): number {
        return this._investment;
    }

    set investment(value: number) {
        this._investment = value;
    }

    get evaluationType(): string {
        return this._evaluationType;
    }

    set evaluationType(value: string) {
        this._evaluationType = value;
    }

    isComplete() {
        return !!this.modelId && this.investment > 0;
    }
}
